import { useState } from "react";
import { api } from "../../../lib/api";
import { Button } from "../../../components/ui/button";
import { Textarea } from "../../../components/ui/textarea";
import { ShieldX, ShieldAlert } from "lucide-react";

export default function ListAlertStep({ visit, onOverride, onCancel }) {
  const [reason, setReason] = useState("");
  const isBlacklist = visit.list_match.list_type === "blacklist";

  const submitOverride = async () => {
    await api.post(`/visits/${visit.id}/override`, { reason });
    onOverride();
  };

  if (isBlacklist) {
    return (
      <div className="fixed inset-0 bg-red-600 text-white flex flex-col items-center justify-center p-8 text-center z-50" data-testid="blacklist-block-screen">
        <ShieldX size={80} className="mb-6" />
        <h1 className="text-4xl font-black uppercase tracking-tighter mb-3">Entry Blocked</h1>
        <p className="text-lg max-w-md mb-2">{visit.visitor_name} is on the security blacklist.</p>
        <p className="text-sm opacity-80 max-w-md mb-8">Reason: {visit.list_match.reason}</p>
        <p className="text-sm uppercase tracking-widest mb-8">Admin &amp; security have been notified. Contact your supervisor.</p>
        <Button onClick={onCancel} data-testid="blacklist-acknowledge-button" className="h-14 px-8 rounded-sm bg-black text-white hover:bg-zinc-900 font-bold uppercase">
          Acknowledge
        </Button>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-amber-500 text-black flex flex-col items-center justify-center p-8 text-center z-50" data-testid="watchlist-warning-screen">
      <ShieldAlert size={80} className="mb-6" />
      <h1 className="text-4xl font-black uppercase tracking-tighter mb-3">Watchlist Warning</h1>
      <p className="text-lg max-w-md mb-2">{visit.visitor_name} matches a watchlist entry.</p>
      <p className="text-sm opacity-80 max-w-md mb-8">Reason: {visit.list_match.reason}</p>
      <div className="w-full max-w-md space-y-3">
        <Textarea
          data-testid="override-reason-input"
          placeholder="Supervisor override reason (required)"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="bg-white border-black rounded-sm"
        />
        <div className="flex gap-3">
          <Button onClick={onCancel} data-testid="watchlist-cancel-button" variant="outline" className="flex-1 h-14 rounded-sm border-black text-black hover:bg-black hover:text-white font-bold uppercase">
            Cancel Entry
          </Button>
          <Button onClick={submitOverride} disabled={!reason} data-testid="watchlist-override-button" className="flex-1 h-14 rounded-sm bg-black text-white hover:bg-zinc-800 font-bold uppercase">
            Approve &amp; Continue
          </Button>
        </div>
      </div>
    </div>
  );
}
